import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import {
  SelectInput,
} from '../Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

import styles from '../../../../css/settings.module.css'

function EngineRunning ({ intl, ...props }) {
  const [state, setState] = useState({
    test: props.test,
    formula: props.formula,
    valueKey: props.valueKey,
    template: props.template,
    testValue: props.testValue,
    multiplier: props.multiplier,
    body: props.body,
    subject: props.subject,
    debounceTime: props.debounceTime,
    sendOnce: props.sendOnce,
    notificationInterval: props.notificationInterval,
    type: props.type,
    invalid: false,
  })

  const updateNewRule = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'update-new-rule-parameters',
      test: state.test,
      formula: state.formula,
      valueKey: state.valueKey,
      template: state.template,
      testValue: state.testValue,
      multiplier: state.multiplier,
      body: state.body,
      subject: state.subject,
      debounceTime: state.debounceTime,
      sendOnce: state.sendOnce,
      notificationInterval: state.notificationInterval,
      type: state.type,
      invalid: state.invalid,
    })
  }, [props.template, state])

  useEffect(() => {
    updateNewRule()
  }, [updateNewRule])

  const handleChangeInterval = useCallback((field, value, callback) => {
    setState((prevState) => ({
      ...prevState,
      [field]: Number(value),
    }))

    if (callback) setTimeout(callback, 0)
  }, [])

  const handleChange = useCallback((field, value, callback) => {
    let valueU = value
    if (field === 'sendOnce') {
      valueU = value === 'true'
    }

    setState((prevState) => ({
      ...prevState,
      [field]: valueU,
    }))

    if (callback) setTimeout(callback, 0)
  }, [])

  const childChange = useCallback((event) => {
    switch (event.target.name) {
      case 'valueKey':
      case 'method':
      case 'sendOnce':
        handleChange(event.target.name, event.target.value)
        break
      case 'notificationInterval':
        handleChangeInterval(event.target.name, event.target.value)
        break
      default:
        break
    }
  }, [handleChange, handleChangeInterval])

  const { formatMessage } = intl

  return (
    <div>
      <section>
        <FormattedMessage
          id='rules.snooze.name'
          defaultMessage='Snooze Alerts'
          description='Snooze Alerts heading'
          tagName='h5'
        />
        <div className={styles.ruleSelect}>
          <SelectInput
            value={state.notificationInterval}
            field='notificationInterval'
            childChange={childChange}
            options={[
              {
                value: 0,
                name: formatMessage({
                  id: 'rules.reminders.never',
                  defaultMessage: 'None',
                  description: 'None option',
                }),
              },
              {
                value: 900000,
                name: formatMessage({
                  id: 'rules.reminders.every15Min',
                  defaultMessage: '15 minutes',
                  description: '15 minutes option',
                }),
              },
              {
                value: 3600000,
                name: formatMessage({
                  id: 'rules.reminders.every1Hrs',
                  defaultMessage: '1 hour',
                  description: '1 hour option',
                }),
              },
              {
                value: 14400000,
                name: formatMessage({
                  id: 'rules.reminders.every4Hrs',
                  defaultMessage: '4 hours',
                  description: '4 hours option',
                }),
              },
              {
                value: 64800000,
                name: formatMessage({
                  id: 'rules.reminders.every18Hrs',
                  defaultMessage: '18 hours',
                  description: '18 hours option',
                }),
              },
              {
                value: 86400000,
                name: formatMessage({
                  id: 'rules.reminders.every24Hrs',
                  defaultMessage: '24 hours',
                  description: '24 hours option',
                }),
              },
            ]}
            style={styles.ruleSelectInput}
          />
        </div>
      </section>
      <section>
        <FormattedMessage
          id='rules.reminders.name'
          defaultMessage='Send Reminders'
          description='Send Reminders heading'
          tagName='h5'
        />
        <div className={styles.ruleSelect}>
          <SelectInput
            value={state.sendOnce}
            field='sendOnce'
            childChange={childChange}
            options={[
              {
                value: true,
                name: formatMessage({
                  id: 'rules.sendOnce.off',
                  defaultMessage: 'Off',
                  description: 'Off option',
                }),
              },
              {
                value: false,
                name: formatMessage({
                  id: 'rules.sendOnce.on',
                  defaultMessage: 'On',
                  description: 'On option',
                }),
              },
            ]}
            style={styles.ruleSelectInput}
          />
        </div>
      </section>
    </div>
  )
}

EngineRunning.propTypes = {
  rule: PropTypes.object,
  intl: PropTypes.object.isRequired,
  test: PropTypes.any,
  formula: PropTypes.string,
  valueKey: PropTypes.string,
  template: PropTypes.string,
  testValue: PropTypes.any,
  multiplier: PropTypes.number,
  body: PropTypes.string,
  subject: PropTypes.string,
  debounceTime: PropTypes.number,
  sendOnce: PropTypes.bool,
  notificationInterval: PropTypes.number,
  type: PropTypes.string,
}

export default injectIntl(EngineRunning)
